// extracted by mini-css-extract-plugin
module.exports = {"tag":"index_tag__nTsSB","filterListContainer":"index_filterListContainer__2gGEK"};